module.exports = __webpack_public_path__ + "static/Resume - Reino S Muhl-3b7e5b1b16c8d6e5fd910d6a3863e8f6.pdf";